import $http from './helpers/axios.jsx';
import axios from 'axios';

const $generateUrl = axios.create({
	baseURL: '',
});

const repositories = {
	auth: {
		login: (payload) => $http.post('/auth/login', payload).then(response => response.data),
		register: (payload) => $http.post('/auth/register', payload).then(response => response.data),
		loginWithGoogle: (payload) => $http.post('/auth/login/google', payload).then(response => response.data),
		registerWithGoogle: (payload) => $http.post('/auth/register/google', payload).then(response => response.data),
		forgotPassword: (payload) => $http.post('/auth/forgot-password', payload).then(response => response.data),
		verifyAccount: (payload) => $http.post(`/auth/verify/${payload}`).then(response => response.data),
		verifyResetToken: (payload) => $http.get(`/auth/reset-password/${payload}`, payload).then(response => response.data),
		resetPassword: (payload) => $http.post(`/auth/reset-password/${payload?.token}`, payload).then(response => response.data),
		
		me: (payload) => $http.get('/users/me').then(response => response.data),
		updateAccount: (payload) => $http.put('/users/edit', payload).then(response => response.data),
		uploadAvatar: (payload) => $http.post('/users/upload-photo', payload).then(response => response.data),
	},
	
	generatePresignedUrl: (payload) => $http.post(`/projects/generate-presigned-url`, payload).then(response => response.data),
	getUploadedFile: (payload) => $http.get(`/projects/get-uploaded-file/${payload}`).then(response => response.data),
	
	speakers: (payload) => $http.get(`/projects/speakers/`, {params: payload}).then(response => response.data),
	allLanguages: (payload) => $http.get(`/projects/language`).then(response => response.data),
	addBookmarkSpeaker: (payload) => $http.post(`/projects/voice-bookmark/${payload}`, payload).then(response => response.data),
	
	
	project: {
		voiceList: (payload) => $http.get(`/projects/voice-list`, {
			params: payload
		}).then(response => response.data),
		generateVoice: (payload) => $http.post(`/projects/voice-add`, payload).then(response => response.data),
		deleteCloneVoice : (speaker_id) => $http.delete(`/projects/speaker/${speaker_id}/voice`, ).then(response => response.data),

		languages: (payload) => new Promise(resolve => resolve([
			{
				id: 999,
				code: 'auto',
				language: 'Auto detect',
			},
			{
				id: 1,
				code: 'English',
				language: 'English',
			},
			{
				id: 2,
				code: 'Hindi',
				language: 'Hindi',
			},
			{
				id: 4,
				code: 'Cantonese',
				language: 'Cantonese',
			},
			{
				id: 5,
				code: 'Mandarin',
				language: 'Mandarin',
			},
		])),
		
		addSpeaker: (payload) => $http.post(`/projects/${payload?.project_id}/add/speaker`, payload?.newSpeakers).then(response => response.data),
		updateSpeaker: (projectID, payload) => $http.post(`/projects/${projectID}/edit/speaker`, payload).then(response => response.data),
		
		regenerate: (payload) => $http.post(`/projects/regenerate/${payload}`).then(response => response.data),
		list: (payload) => $http.get('/projects/list', {
			params: payload
		}).then(response => response.data),
		showProject: (payload) => $http.get(`/projects/${payload}`, payload).then(response => response.data),
		voiceSuggestions: (payload) => $http.get(`/projects/voice-suggestion`, payload).then(response => response.data),
		
		uploadFile: (payload) => $http.post('/projects/upload-video', payload).then(response => response.data),
		startYoutube: (payload) => $http.post('/projects/youtube/start', payload).then(response => response.data),
		youtubeStatus: (video_id) => $http.get('/projects/youtube/status', {params: {video_id}}).then(response => response.data),
		create: (payload) => $http.post('/projects/submit', payload).then(response => response.data),
		
		renameProject: (payload) => $http.put(`/projects/rename`, payload).then(response => response.data),
		deleteProject: (payload) => $http.delete(`/projects/${payload?.id}/delete`, payload).then(response => response.data),
		
		cloneProject: (payload) => $http.post(`/projects/${payload?.project_id}/clone`, payload).then(response => response.data),
		
		regenerateSegment: (payload) => $http.post(`/projects/generate-segment`, payload).then(response => response.data),
		regenerateSegmentAudio: (payload) => $http.post(`/projects/generate-segment-audio`, payload).then(response => response.data),
		
		updateSrt: (payload) => $http.put(`/projects/${payload?.project_id}/edit`, payload).then(response => response.data),
		deleteSrt: (payload) => $http.delete(`/projects/${payload?.project_id}/delete/${payload?.srt_id}`, payload).then(response => response.data),
		
		exportOriginalVideo: (payload) => $http.post(`/projects/video/export`, payload).then(response => response.data),
		exportVideo: (payload) => $http.post(`/projects/translated-video/export`, payload).then(response => response.data),
		buyCredits: (payload) => $http.post(`/projects/buy-editing-quota/${payload?.project_id}`, payload).then(response => response.data),
		
	},
	
	subscription: {
		plans: (payload) => $http.get(`/plan/plans`).then(response => response.data),
		createSubscription: (payload) => $http.post(`/subscription/stripe/create-subscription`, payload).then(response => response.data),
		checkSubscription: (payload) => $http.post(`/subscription/stripe/confirmation`, payload).then(response => response.data),
		purchaseCredit: (payload) => $http.post(`/subscription/stripe/pro-purchase-credit`, payload).then(response => response.data),
		manageBilling: (payload) => $http.get(`/subscription/stripe/billing-portal-session`, payload).then(response => response.data),
	},
	
	textToSpeech: {
		config: (payload) => $http.get(`/text-to-speech/settings`, payload).then(response => response.data),
		voices: (payload) => $http.post(`/text-to-speech/voices`, payload).then(response => response.data),
		generate: (payload) => $http.post(`/text-to-speech/generate`, payload).then(response => response.data),
		history: (payload) => $http.get(`/text-to-speech/history`, {params: payload}).then(response => response.data),
	},

	channel: {
		list: () => $http.get('/channels').then(response => response.data),
		youtubeConnect: (params) => $http.get('/channels/youtube/connect', {params}).then(response => response.data),
		disconnect: (id) => $http.delete(`/channels/${id}`).then(response => response.data),
		videos: (id) => $http.get(`/channels/${id}/videos`).then(response => response.data),
		playlists: (id) => $http.get(`/channels/${id}/playlists`).then(response => response.data),
	},

	autoDub: {
		config: () => $http.get('/auto-dub/config').then(response => response.data),
		workflows: {
			list: () => $http.get('/workflows').then(response => response.data),
			create: (payload) => $http.post('/workflows', payload).then(response => response.data),
			get: (id) => $http.get(`/workflows/${id}`).then(response => response.data),
			update: (id, payload) => $http.patch(`/workflows/${id}`, payload).then(response => response.data),
			remove: (id) => $http.delete(`/workflows/${id}`).then(response => response.data),
		},
		queue: (id) => $http.get(`/workflows/${id}/queue`).then(response => response.data),
		approve: (id, item) => $http.post(`/workflows/${id}/queue/${item}/approve`).then(response => response.data),
		retry: (id, item) => $http.post(`/workflows/${id}/queue/${item}/retry`).then(response => response.data),
	}
}

export default repositories;
